import * as React from "react";
const SvgIcon77 = props => <svg xmlns="http://www.w3.org/2000/svg" fill="none" width="1em" height="1em" viewBox="0 0 30 30" {...props}><circle cx={15} cy={15} fill="currentColor" r={15} style={{
    opacity: 0.09
  }} /><circle cx={9} cy={15} fill="currentColor" r={1.5} /><circle cx={15} cy={15} fill="currentColor" r={1.5} /><circle cx={21} cy={15} fill="currentColor" r={1.5} /></svg>;
export default SvgIcon77;